import { defineStore } from 'pinia';
import { type AccountInfo } from '@azure/msal-browser';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    isAuthenticated: false,
    user: null as AccountInfo | null,
    loginError: null as string | null
  }),

  persist: true,

  actions: {
    setAuthenticated(value: boolean) {
      this.isAuthenticated = value;
    },

    setUser(user: AccountInfo | null) {
      this.user = user;
    },

    setLoginError(message: string | null) {
      this.loginError = message;
    },

    clearAuth() {
      this.isAuthenticated = false;
      this.user = null;
    }
  }
});
